import { filterDish } from './dishSearch';
import { toastError, toastSuccess } from '../utils/toastMessage';
import API from '../utils/API';

export const confirmDeletingDish = (name, id) => {
  return {
    type: 'DELETE_DISH_CONFIRM',
    name,
    id,
  };
};

export const deleteDishSuccess = (data) => {
  return {
    type: 'DELETE_DISH_SUCCESS',
    data,
  };
};

export const deleteDishError = (data) => {
  return {
    type: 'DELETE_DISH_ERROR',
    data,
  };
};

export const cancelDeletingDish = () => {
  return {
    type: 'DELETE_CANCEL',
  };
};

export const deleteDish = (id) => {
  return (dispatch, getState) => {
    const { currentDishesPage } = getState().dishSearch;
    const { searchParam, filterParam, sortParam, order } = getState().searchParams;
    API.delete(`/dishes/${id}`)
      .then((response) => {
        toastSuccess();
        dispatch(deleteDishSuccess(response.data));
        const sort = sortParam.slice(0, -1);
        dispatch(filterDish(searchParam, filterParam, sort, order, currentDishesPage, true));
      })
      .catch(() => {
        dispatch(deleteDishError());
        toastError('В процессе удаления блюда произошла ошибка');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/dishDelete.js